import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSupportGray = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "-8 -8 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "2.5em",
	height: "2.5em",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
			fill: "#E6E6E6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 18.5C12.2761 18.5 12.5 18.2851 12.5 18.02C12.5 17.7549 12.2761 17.54 12 17.54C11.7239 17.54 11.5 17.7549 11.5 18.02C11.5 18.2851 11.7239 18.5 12 18.5Z",
			fill: "#E6E6E6",
			stroke: "#808080"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.5 7.05382C11.5406 6.18812 14.181 6.29101 15.0828 7.69197C15.9846 9.09293 15.3621 10.7224 13.8162 11.9799C12.2703 13.2374 11.7127 13.9201 11.7127 14.9095",
			fill: "#E6E6E6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.5 7.05382C11.5406 6.18812 14.181 6.29101 15.0828 7.69197C15.9846 9.09293 15.3621 10.7224 13.8162 11.9799C12.2703 13.2374 11.7127 13.9201 11.7127 14.9095",
			stroke: "#808080",
			strokeMiterlimit: 10,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgSupportGray);
export default ForwardRef;
